import { useCustomerSettingQuery } from '@/services/customer/customer/customer.queries';

export const FF_PROJECTS_V2 = 'projects_v2_enabled' as const;

type FeatureFlagState = {
    enabled: boolean;
    isResolved: boolean;
};

export const useFeatureFlag = (idn: string): FeatureFlagState => {
    const { data, isPending } = useCustomerSettingQuery(idn);

    return {
        enabled: data?.value === 'true',
        isResolved: !isPending
    };
};
